import type { IconDefinition } from '../index.tsx';

export const iconHourglass: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconHourglass',
  icon: [
    16,
    16,
    [],
    '',
    'M13 14V13.3438C13 12.4688 12.7188 11.6562 12.1875 10.9375L10 8L12.1875 5.09375C12.7188 4.375 13 3.53125 13 2.6875V0C11.7193 0 3 0 3 0V2.6875C3 3.5625 3.25 4.375 3.78125 5.09375L6 8L3.78125 10.9375C3.25 11.625 3 12.4688 3 13.3438V16C3 16 11.7106 16 13 16V14ZM5 14V13.3438C5 12.9062 5.125 12.5 5.375 12.1562L8 8.6875L10.5938 12.1562C10.8438 12.5 11 12.9062 11 13.3438V14H5Z',
  ],
};
